import { useEffect } from 'react';
import enviro from 'enviro';
import { useWidgetDetails } from 'worker-connection-library/hooks/useWidgetDetails';
import { getActiveCallDetails, getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getCallSource } from 'calling-cross-tab-library/appData/operators/activeCallDetailsOperators';
import { getShouldShowEndCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { CallSource } from 'calling-cross-tab-library/constants/CallSource';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import { capabilities } from 'navigation-components/capabilities';
import { REDESIGN_CSAT_SURVEY_ID } from 'calling-internal-common/constants/CsatSurveyIds';
export const useOpenDialerCsat = () => {
  const {
    widgetDetails
  } = useWidgetDetails();
  const activeCallDetails = getActiveCallDetails(widgetDetails);
  const callStatus = getCallStatus(widgetDetails);
  const callSource = activeCallDetails && getCallSource(activeCallDetails);
  const shouldShowEndCallState = getShouldShowEndCallState(callStatus);
  const openSurvey = useInvokeCapability(capabilities.TOGGLE_CSAT_SURVEY_CAP);
  useEffect(() => {
    if (enviro.isProd() && shouldShowEndCallState && callSource === CallSource.OUTBOUND_DIALER) {
      openSurvey({
        surveyId: REDESIGN_CSAT_SURVEY_ID
      });
    }
  }, [callSource, openSurvey, shouldShowEndCallState]);
};